import { useEffect, useState } from 'react';

import { CalendarGrid } from '@features/task-management-calendar/components/CalendarGrid';

const TaskManagementCalendar = ({ events, viewMode, currentDate, handleEvent, handleSelectedDate }) => {
	const [eventList, setEventList] = useState([]);

	const getProjectColors = (type, projectStatus) => {
		if (projectStatus === 'COMPLETED') return 'event-gray';
		switch (type) {
			case 'BUYER_SIGN_OFF':
				return 'event-blue';
			case 'BUYER_VISIT_IN_UK':
			case 'BUYER_VISIT_IN_BD':
			case 'BUYER_VISIT_IN_SP':
				return 'event-yellow';
			default:
				return 'event-green';
		}
	};

	useEffect(() => {
		let tmpEvents = [];
		for (let item in events) {
			tmpEvents = [...tmpEvents, ...events[item].data];
		}
		setEventList(
			tmpEvents.map((item) => {
				let milestoneDates = item?.projectMilestoneDateList?.map((date) => {
					let tmpDate = date.split('-');
					return new Date(tmpDate[0], tmpDate[1] - 1, tmpDate[2]);
				});
				return {
					id: item.id,
					title: item.name,
					projectType: item.projectTypeName,
					brand: item?.brandResponse?.name,
					color: getProjectColors(item.ProjectType, item.projectStatus),
					milestoneDates: milestoneDates
				};
			})
		);
	}, [events]);

	return (
		<div className="task-management-calendar-container bg-white d-flex flex-column pt-4">
			<CalendarGrid
				currentDate={currentDate}
				events={eventList}
				viewMode={viewMode}
				handleEvent={handleEvent}
				handleSelectedDate={handleSelectedDate}
			/>
		</div>
	);
};

export default TaskManagementCalendar;
